import styled from 'styled-components';
import { rem } from '@mantine/core';

export const GreyBox = styled.div`
	padding: 1rem;
	width: 100%;
	border-radius: 0.5rem;
	background-color: ${(props) => props.theme.v3.colors.gray[0]};
`;

export const WhiteSquare = styled.div`
	height: ${rem(40)};
	width: ${rem(40)};
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: ${(props) => props.theme.v3.colors.white[0]};
	border: 1px solid ${(props) => props.theme.v3.colors.gray[4]};
	border-radius: 0.5rem;
`;

export const DetailsBox = styled.div`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	min-width: 15rem;
	width: 35%;
	border-radius: 0.5rem;
	border: 1px solid ${(props) => props.theme.v3.colors.gray[2]};
`;

export const DetailsBoxContent = styled.div`
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding: 1rem;
`;
